<template>
  <v-dialog v-model="value" persistent max-width="945px">
    <v-card>
      <v-toolbar
        color="headformsdark"
        height="45"
        elevation="0"
        dense
        dark>
        <v-spacer></v-spacer>
        <span class="mdlHeadForms" v-if="nNuevo==0">Agregar Links Crontabs</span>
        <span class="mdlHeadForms" v-else-if="nNuevo==1">Actualizar Links Crontabs</span>
        <span class="mdlHeadForms" v-else>Detalle Links Crontabs</span>
        <v-spacer></v-spacer>
        <v-btn 
          color="btncolor-dark"
          @click="CloseDialog()"
          icon
          small
          dark
          outlined>
          <v-icon size="14px">fa fa-times</v-icon>
        </v-btn>
      </v-toolbar>
      <v-row >
        <v-col cols="12">
            <span class="mdlHeadForms">Link de EndPoint a correr <span v-if="nNuevo!=0"> - ID ({{ nIdCrontab }})</span></span>
        </v-col>
        <v-col cols="12">
            <v-text-field
                v-model="sLink"
                :rules="aReglasLink"
                :disabled="nNuevo==2"
                label="Link"
                required
            ></v-text-field>
        </v-col> 
        <v-col cols="12">
            <span class="mdlHeadForms">Tipo de petición</span>
        </v-col>
        <v-col cols="12">
            <v-radio-group v-model="sPeticion">
                <v-radio
                    :disabled="nNuevo==2"
                    v-for="n in aTiposPeticion"
                    :key="n"
                    :label="`${n}`"
                    :value="n"
                ></v-radio>
                </v-radio-group>
        </v-col> 
        <v-col cols="12">
            <span class="mdlHeadForms">Dias en los que se van a repetir</span>
        </v-col>
        <v-col :class="{ 'bloqueado': nNuevo==2 }">
            <v-btn
                v-for="(dia, key) in oDias"
                :key="key"
                :outlined="!dia.selected"
                :disabled="dia.disabled"
                class="mx-auto"
                :dark="!dia.disabled"
                color="#00A7C6"
                width="120px"
                @click="onSeleccionarDia(key)"
                :id="`BtnDiasHorario_${key}`"
            >
                {{ key.substring(0, 3) }}
            </v-btn>
        </v-col>
        <v-col cols="12">
            <span class="mdlHeadForms" v-if="nNuevo!=2">Agregue las horas que desee que se repita</span>
            <span class="mdlHeadForms" v-else>Horas configuradas que se repiten</span>
        </v-col>
        <v-col cols="5" v-if="nNuevo!=2">
            <v-menu
                ref="menu"
                v-model="bHora"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="sHora"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-row>
                        <v-text-field
                            v-model="sHora"
                            prepend-icon="mdi-clock-time-four-outline"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                        <v-btn
                            class="mx-2"
                            fab
                            dark
                            small
                            color="primary"
                            @click="onAgregarHora"
                            >
                            <v-icon dark>
                                mdi-plus
                            </v-icon>
                        </v-btn>
                    </v-row>
                </template>
                <v-time-picker
                v-if="bHora"
                v-model="sHora"
                full-width
                format="24hr"
                @click:minute="$refs.menu.save(sHora)"
                ></v-time-picker>
            </v-menu>            
        </v-col>
        <v-col cols="5">
            <v-row>
                <v-col
                    cols="4"
                    v-for="(sHoraTemp, index) in aListadoHoras"
                    :key="index"
                    >
                        <v-chip
                            label
                            outlined
                            :close="nNuevo!=2"
                            color="blue"
                            @click:close="eliminarHora(index)"
                            >
                            {{ sHoraTemp }}
                        </v-chip>
                </v-col>
            </v-row>

        </v-col>
        <v-col cols="12">
            <span class="mdlHeadForms" v-if="nNuevo!=2">Asocie los clientes que recorreran el endpoint</span>
            <span class="mdlHeadForms" v-else>Clientes asociados y fechas de ejecucion</span>
        </v-col>
        <v-col cols="12" v-if="nNuevo!=2">
            <FormAgregarClientes 
              :key="nKeyLista"
              ref="formAgregarClientes"
              :aData="aDatosFormulario"
              @aDataResp="onPasarRespuestas"
              titulo="Clientes"
              :obligatorio="true"
            />
        </v-col>
        <v-col cols="12" v-else>
            <v-simple-table>
                <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                            Cliente
                        </th>
                        <th class="text-left">
                            Dominio
                        </th>
                        <th class="text-left">
                            Hora
                        </th>
                        <th class="text-left">
                            Fecha Ultima Ejecución
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="item in aClientesEjecutados"
                        :key="item.dominio"
                        >
                        <td>{{ item.cliente }}</td>
                        <td>{{ item.dominio }}</td>
                        <td>{{ item.Hora }}</td>
                        <td>{{ item.fechaEjecutada == null ? 'Sin Fecha':item.fechaEjecutada }}</td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>
        </v-col>
      </v-row>   
      <v-card-actions class="mb-3">
        <v-btn class="btn-rounded d-flex mx-2 mx-auto" depressed light outlined color="buttondark" @click="CloseDialog">Cancelar</v-btn>
        <v-btn class="btn-rounded d-flex mx-2 mx-auto" depressed color="primary" @click="onEnviarForm" v-if="nNuevo!=2">
            <span v-if="nNuevo==0">Guardar</span>
            <span v-else>Actualizar</span>
        </v-btn>
      </v-card-actions> 
    </v-card>
    <ErrorView v-model="bMostrarErrores" :aErrores="aErrores"></ErrorView>
  </v-dialog> 
  
</template>

<script>

import FormAgregarClientes from '@/components/Crontabs/FormAgregarClientes.vue';
import ErrorView from '@/components/ErrorView.vue';
import axiosServices from "@/services/axiosServices.js";

export default {
    name: "FromularioCronTabs",
    data() {
      return {
        sLink: '',
        aReglasLink: [
            v => !!v || 'El link es requerido',
            v => this.validarURL(v) || 'Debe ser una URL válida'
        ],
        oDias: {
            Lunes: { selected: false, disabled: false },
            Martes: { selected: false, disabled: false },
            Miercoles: { selected: false, disabled: false },
            Jueves: { selected: false, disabled: false },
            Viernes: { selected: false, disabled: false },
            Sabado: { selected: false, disabled: false },
            Domingo: { selected: false, disabled: false },
        },
        sHora:"",
        aListadoHoras:[],
        bHora:false,
        nKeyLista: 0,
        aDatosFormulario: [],
        aDatosFormularioTemp: [],
        aFormulariosSeleccionados:[],
        aErrores:[],
        bMostrarErrores:false,
        aClientesEjecutados:[],
        aTiposPeticion:[
            "GET",
            "POST",
            "PUT",
        ],
        sPeticion:""
      }
    },
    components: {
        FormAgregarClientes,
        ErrorView
    },
    props: {
      value: {
        type: Boolean,
        default: false
      },
      nNuevo: { /* 0 -> nuevo, 1 -> Editar, 2 -> Detalle */
        type: Number,
        default: 0
      },
      nIdCrontab: {
        type: String,
        default: "0"
      },
      
    },
    methods: {
        CloseDialog() {
            this.$emit('input', false)
        },
        onSeleccionarDia(sDia) { // Cambia el estado selected al hacer clic sobre un dia
            this.oDias[sDia].selected = !this.oDias[sDia].selected
        },
        validarURL(valor) {
            try {
            const url = new URL(valor);
                return url.protocol === 'http:' || url.protocol === 'https:';
            } catch (_) {
                return false;
            }
        },
        onAgregarHora(){
            if(this.sHora!=""){
                this.aListadoHoras.push(this.sHora);
                this.sHora = "";
            }
        },
        eliminarHora(index) {
            this.aListadoHoras.splice(index, 1);
        },
        onPasarRespuestas(aItems) {
            if (aItems?.length > 0) {
                this.aFormulariosSeleccionados = aItems;
            }
        },
        async onEnviarForm(){
            this.aErrores = [];
            //Validamos que venga toda la informacion este correcta
            if(this.sLink==""||!this.validarURL(this.sLink)){
                this.aErrores.push("El link no es correcto");
            }
            
            if(this.aListadoHoras.length==0){
                this.aErrores.push("Debe agregar almenos una hora");
            }
            if(this.aFormulariosSeleccionados.length==0){
                this.aErrores.push("Debe seleccionar almenos un cliente");
            }

            //Validamos que al menos tengan un dia seleccionado
            let aDias = [];
            if(this.oDias.Domingo.selected){
                aDias.push("Domingo")
            }
            if(this.oDias.Jueves.selected){
                aDias.push("Jueves")
            }
            if(this.oDias.Lunes.selected){
                aDias.push("Lunes")
            }
            if(this.oDias.Martes.selected){
                aDias.push("Martes")
            }
            if(this.oDias.Miercoles.selected){
                aDias.push("Miercoles")
            }
            if(this.oDias.Sabado.selected){
                aDias.push("Sabado")
            }
            if(this.oDias.Viernes.selected){
                aDias.push("Viernes")
            }

            if(aDias.length==0){
                this.aErrores.push("Debe seleccionar almenos un Dia");
            }

            if(this.sPeticion==""){
                this.aErrores.push("Debe seleccionar almenos un Tipo de petición");
            }

            if(this.aErrores.length>0){
                this.bMostrarErrores = true;
                return;
            }
            let oDatosEnviar = {
                aDias:aDias,
                aHoras: this.aListadoHoras,
                aClientes:this.aFormulariosSeleccionados,
                sLink:this.sLink,
                nIdCrontab:this.nIdCrontab,
                sPeticion:this.sPeticion
            };
            //Validamos si esta creando uno o esta actualizando uno
            let  oResponse = {};
            if(this.nNuevo==0){
                oResponse = await axiosServices.postConfiguration(`/crontabs/crearCrontab`,oDatosEnviar);
            }
            else{
                oResponse = await axiosServices.putConfiguration(`/crontabs/crearCrontab`,oDatosEnviar);
            }
            if (oResponse.sStatus == 'success'){
                this.bCargando = true
                this.$swal({
                    timer: 1500,
                    icon:`${oResponse.sStatus}`,
                    title:`Registro Exitoso!`,
                    showConfirmButton: false
                });
                this.$emit("onActualizarGrid")
                this.CloseDialog();
            }
            else{
                this.$swal({
                    timer: 1500,
                    icon:`error`,
                    title:`Error al Registrar`,
                    showConfirmButton: false
                });
            }
            
        },
        async onCargarInformacion(){
            //Validamos que si es una edicion consultamos la informacion relacionada al crontab
            if(this.nNuevo!=0){
            //Consultamos la informacion del crontab para cargar el formulario
            axiosServices
                .getConfiguration("/crontabs/"+this.nIdCrontab,true)
                .then((aItems) => {

                    //Recorremos los dias que tiene seleccionado
                    aItems.aData.aDias.forEach(aDiaTemp => {
                        switch (aDiaTemp) {
                            case "Lunes":
                                this.oDias.Lunes.selected=true;
                            break;
                            case "Martes":
                                this.oDias.Martes.selected=true;
                            break;
                            case "Miercoles":
                                this.oDias.Miercoles.selected=true;
                            break;
                            case "Jueves":
                                this.oDias.Jueves.selected=true;
                            break;
                            case "Viernes":
                                this.oDias.Viernes.selected=true;
                            break;
                            case "Sabado":
                                this.oDias.Sabado.selected=true;
                            break;
                            case "Domingo":
                                this.oDias.Domingo.selected=true;
                            break;
                        }
                    });

                    this.aListadoHoras = aItems.aData.aHoras;
                    this.sLink = aItems.aData.sLink;
                    this.aClientesEjecutados = aItems.aData.aClientesEjecutados
                    this.sPeticion = aItems.aData.sPeticion
                    if(this.nNuevo==1){
                        this.$refs.formAgregarClientes.onAgregarClientes(aItems.aData.aClientes);
                    }
                });
                
            }
        }
    },
    async mounted(){
        if(this.nNuevo!=0){
            await this.onCargarInformacion();
        }
    }
    
  }
</script>

<style lang="scss" scoped>
.bloqueado {
  pointer-events: none;
  opacity: 0.6;
}
</style>